import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { applyBranding, type Branding } from "./branding";
import { DEFAULT_LANGUAGE } from "./config";
import { resources } from "./resources";

export type I18nPlugin = Parameters<typeof i18next.use>[0];

export interface InitI18nOptions {
  plugins?: I18nPlugin[];
  debug?: boolean;
  /** Deployment-provided product name and tagline; anything omitted keeps the locale-file value. */
  branding?: Branding;
}

export const initI18n = ({ plugins = [], debug = false, branding }: InitI18nOptions = {}) => {
  i18next.use(initReactI18next);
  plugins.forEach((plugin) => i18next.use(plugin));
  void i18next.init({
    // A copy: i18next keeps the object it is given and `applyBranding` writes into it, which would
    // leave the imported bundles no longer matching the locale files. JSON round-trip rather than
    // `structuredClone`, which Hermes does not guarantee; the bundles are plain JSON, nothing is lost.
    resources: JSON.parse(JSON.stringify(resources)) as typeof resources,
    defaultNS: "common",
    fallbackLng: DEFAULT_LANGUAGE,
    debug,
    interpolation: {
      escapeValue: false,
    },
  });
  // `resources` is passed inline, so the store is populated by the time `init` returns and the
  // overrides land before the first render.
  if (branding) applyBranding(i18next, branding);
  return i18next;
};

export const logI18nSetup = () => {
  console.info("i18next initialized", i18next.t("i18nInitialized"));
};
